import { useHistory } from 'react-router-dom';
import { RoutingFunctionParams, RouteTo } from './types';
import useModuleRoute from './useModuleRoute';

const useBaseHistory = () => {
  const history = useHistory();
  const { moduleUrl } = useModuleRoute();

  const pushOrReplace = (routingFunction: RoutingFunctionParams, to: RouteTo, state?: unknown) => {
    let pathname;
    if (typeof to === 'string') {
      pathname = `${moduleUrl}${to}`;
    } else {
      pathname = {
        ...to,
        pathname: to.pathname ? `${moduleUrl}${to.pathname}` : undefined,
      };
    }
    routingFunction(pathname, state);
  };

  return {
    ...history,
    // eslint-disable-next-line @typescript-eslint/unbound-method
    push: (to: RouteTo, state?: unknown) => pushOrReplace(history.push, to, state),
    // eslint-disable-next-line @typescript-eslint/unbound-method
    replace: (to: RouteTo, state?: unknown) => pushOrReplace(history.replace, to, state),
  };
};

export default useBaseHistory;
